import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Modal from "../../common/CustomModal";
import { useTranslation } from "react-i18next";
import { useGalleryContext } from "../../../context/GalleryContext";
import { NoImageFeedback } from "./NoImageFeedback";
import { weightSorter } from "../../../helpers/sortUtils";

const OutdoorSports = () => {
  const { t } = useTranslation("gallery");
  const location = useLocation();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const { outdoorSports } = useGalleryContext();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  if (!outdoorSports || outdoorSports.length === 0) {
    return (
      <div
        className="
            min-h-[200px] flex items-center justify-center
            p-4
          "
      >
        <NoImageFeedback />
      </div>
    );
  }

  return (
    <section className="w-full">
      <div className=" maxContainer" id="outdoor-sports">
        <div className="flex flex-col items-center w-full">
          <div className="grid w-full grid-cols-2 mt-12 md:grid-cols-3">
            {weightSorter([...outdoorSports]).map((image, idx) => (
              <div
                key={idx}
                className="relative ss:h-[274px] cursor-pointer border w-full overflow-hidden  group"
              >
                <div
                  className="absolute inset-0 transition-all duration-300 transform bg-center bg-cover group-hover:scale-105"
                  style={{
                    backgroundImage: `url(${image.url})`,
                  }}
                ></div>

                <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-5 py-4 transition-all duration-700 ease-in-out translate-y-5 shadow-lg opacity-0 bg-white/80 backdrop-blur-md group-hover:opacity-100 group-hover:translate-y-0">
                  <span className="text-[10px] ss:text-[14px] font-medium text-[#000000bd]">
                    {t(image.description)}
                  </span>
                </div>

                <img
                  src={image.url}
                  alt="gallery-img"
                  className="object-cover w-full h-full"
                  style={{ opacity: 0 }}
                  onClick={() => setSelectedImage(image.url)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        size="max-content"
      >
        <img
          src={selectedImage!}
          className="object-contain max-h-[80vh] w-auto max-w-full "
          alt="gallery"
        />
      </Modal>
    </section>
  );
};

export default OutdoorSports;
